function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import omit from 'lodash.omit';
import { useTranslation } from 'react-i18next';
const api = buildService('/project_elster_details/{id}/staff_costs', {
  only: ['delete', 'create']
}, {
  only: ['postFormData', 'putFormData']
});
const nameListsService = {
  useNameList: rowData => {
    const [body, setBody] = useState(_objectSpread(_objectSpread({}, rowData), {}, {
      year: rowData.year || 'before_01_07_2020'
    }));
    const [isSaved, setIsSaved] = useState(true);
    const [uploadAllowed, setUploadAllowed] = useState(!!rowData.id); // upload is allowd for existing rows, new rows should update on press of save button

    useEffect(() => {
      rowData.year = rowData.year || 'before_01_07_2020';
      setBody(_objectSpread({}, rowData));
    }, [rowData]);
    return [body, setBody, setUploadAllowed, uploadAllowed, isSaved, setIsSaved];
  },
  useAddData: (setBody, setData, rowData, selectedProject) => {
    const addData = useCallback((response, data) => {
      selectedProject.project_elster_detail.total_for_staff_cost = _objectSpread({}, response.total_calculations);
      setData([...data, response]);
      setBody(_objectSpread({}, rowData));
    }, [rowData, selectedProject, setData, setBody]);
    return [addData];
  },
  useUpdateData: (body, selectedProject, setData) => {
    const updateData = useCallback((response, documentOnly, data) => {
      const selectedDataIndex = data.findIndex(n => n.id === Number(body.id));
      if (documentOnly) {
        data[selectedDataIndex].document = _objectSpread({}, response.document);
      } else {
        data[selectedDataIndex] = _objectSpread({}, response);
      }
      selectedProject.project_elster_detail.total_for_staff_cost = _objectSpread({}, response.total_calculations);
      setData([...data]);
    }, [body.id, selectedProject, setData]);
    return [updateData];
  },
  useUploadFile: (rowData, body, data, updateData) => {
    const uploadFile = useErrorHandling(useCallback(async formData => {
      formData.append('staff_cost', JSON.stringify({
        id: rowData.id
      }));
      const response = await api.putFormData(body.project_elster_detail_id, body.id, formData);
      updateData(response, true, data);
    }, [body, rowData.id, updateData, data]));
    return [uploadFile];
  },
  useSaveData: (data, setIsSaved, updateData) => {
    const saveData = useErrorHandling(useCallback(async body => {
      let fieldValues = omit(body, ['id', 'created_at', 'updated_at', 'project_elster_detail_id']);
      if (body.fulltime) {
        fieldValues = omit(body, ['digital_record', 'rel_agreed_annual_working_hrs']);
      }
      const fd = new FormData();
      fd.append('staff_cost', JSON.stringify(_objectSpread({}, fieldValues)));
      const response = await api.putFormData(body.project_elster_detail_id, body.id, fd);
      updateData(response, false, data);
      setIsSaved(true);
    }, [setIsSaved, updateData, data]));
    return [saveData];
  },
  useCeateData: (setUploadAllowed, body, data, addData, setIsSaved, emptyRowId, removeEmptyRow) => {
    const createNewData = useErrorHandling(useCallback(async function (formData) {
      let bodyOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setUploadAllowed(false);
      const bodyToSave = bodyOverride || body;
      let fieldValues = omit(bodyToSave, ['id', 'created_at', 'updated_at', 'project_elster_detail_id']);
      if (bodyToSave.fulltime) {
        fieldValues = omit(bodyToSave, ['digital_record', 'rel_agreed_annual_working_hrs']);
      }
      formData.append('staff_cost', JSON.stringify(fieldValues));
      const response = await api.postFormData(bodyToSave.project_elster_detail_id, formData);
      addData(response, data);
      setIsSaved(true);
      removeEmptyRow(emptyRowId);
    }, [setIsSaved, setUploadAllowed, addData, data, body, removeEmptyRow, emptyRowId]));
    return [createNewData];
  },
  useDelete: (selectedProject, setData) => {
    const {
      t
    } = useTranslation();
    const deleteData = useErrorHandling(useCallback(async (body, data) => {
      if (!window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_CONFIRMATION_MESSAGE)))) return;
      await api.delete(body.project_elster_detail_id, body.id);
      const deletedNameListIndex = data.findIndex(n => n.id === Number(body.id));
      const newGrossWage = selectedProject.project_elster_detail.total_for_staff_cost.gross_wage_total - body.calculations.gross_wage;
      const newSocialSecurityTotal = selectedProject.project_elster_detail.total_for_staff_cost.b_excluding_special_payments_total - body.calculations.b_excluding_special_payments;
      selectedProject.project_elster_detail.total_for_staff_cost = {
        gross_wage_total: newGrossWage,
        b_excluding_special_payments_total: newSocialSecurityTotal
      };
      data.splice(deletedNameListIndex, 1);
      setData([...data]);
    }, [selectedProject, setData, t]));
    return [deleteData];
  }
};
nameListsService.useCrud = (rowData, selectedProject, data, setData, removeEmptyRow, emptyRowId) => {
  const [body, setBody, setUploadAllowed, uploadAllowed, isSaved, setIsSaved] = nameListsService.useNameList(rowData);
  const [addData] = nameListsService.useAddData(setBody, setData, rowData, selectedProject);
  const [updateData] = nameListsService.useUpdateData(body, selectedProject, setData);
  const [uploadFile] = nameListsService.useUploadFile(rowData, body, data, updateData);
  const [saveData] = nameListsService.useSaveData(data, setIsSaved, updateData);
  const [createNewData] = nameListsService.useCeateData(setUploadAllowed, body, data, addData, setIsSaved, emptyRowId, removeEmptyRow);
  const [deleteData] = nameListsService.useDelete(selectedProject, setData);
  return {
    uploadAllowed,
    body,
    uploadFile,
    saveData,
    createNewData,
    deleteData,
    isSaved,
    setBody,
    setUploadAllowed
  };
};
export default nameListsService;